import React from "react";
import WorkshopReport from "./Common/WorkshopReport";
import TollCollection from "./Rangpo/TollCollection";
import InvoiceGeneratedGraph from "./Common/InvoiceGeneratedGraph";
import OBTS from "./Common/OBTS";

function RangpoDashboard() {
  return (
    <div className="row m-0">
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3">
          <TollCollection />
        </div>
      </div>

      <div className="col col-12 col-md-12  col-lg-6">
        <div className="graph-outline mb-3">
          <InvoiceGeneratedGraph depo="30" />
        </div>
      </div>
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3" style={{ height: "400px" }}>
          <OBTS depo={"30"} />
        </div>
      </div>
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3" style={{ height: "400px" }}>
          <WorkshopReport depo="30" />
        </div>
      </div>
    </div>
  );
}

export default RangpoDashboard;
